import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  GO_BACK_BUTTON: `${cleanedFilename(__filename)}-go-back-button`,
};
